const typographyformEquipServ = {
  text1: 'Sin servicio añadido',
  text2: 'Tipos de Servicios',
  text3: 'Servicios Realizados',
  servicesCompletedTab: 'Servicios Realizados',
  draftsTab: 'Borradores',
  draftStartedAt: 'Iniciado el',
  notDone: 'Sin servicio añadido',
  inDelay: (days) => days === 1 ? `Servicio vencido hace ${days} día` : `Servicio vencido hace ${days} días`,
  hasActionsOpenedOrOverdue: (days) => days === 1 ? `El servicio tiene ${days} acción abierta o vencida` : `El servicio tiene ${days} acciones abiertas o vencidas`,
  zipExport: 'Todos los Servicios (.ZIP)',
  allEquipmentServicesReplicateExportPDF: 'Todos los Servicios (.PDF)',
  simplifiedExport: 'Informe Simplificado (.PDF)',
  allEquipmentServicesReplicateWithAttachmentsExportZip: 'Todos los Servicios con anexos (.Zip)',
};

export default typographyformEquipServ;
